function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 8.25v2.25h-9V8.25H0v2.25c0 .825.675 1.5 1.5 1.5h9c.825 0 1.5-.675 1.5-1.5V8.25h-1.5zm-.75-3L8.693 4.192 6.75 6.128V0h-1.5v6.128L3.308 4.192 2.25 5.25 6 9l3.75-3.75z",
  fill: "currentColor"
});

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "0df674b74efd79f9e37407d23bfc32c5.svg";
export { SvgDownload as ReactComponent };